import {notification} from "antd";

const notify = {
  success: (message, description = "") => {
    notification.success({
      message: message,
      description: description,
      placement: "topRight",
    });
  },

  error: (message, description = "") => {
    notification.error({
      message: message,
      description: description,
      placement: "topRight",
    });
  },

  warning: (message, description = "") => {
    notification.warning({
      message: message,
      description: description,
      placement: "topRight",
    });
  },

  info: (message, description = "") => {
    notification.info({
      message: message,
      description: description,
      placement: "topRight",
    });
  },
};

export default notify;

